import { createSelector, defaultMemoize } from 'reselect';
import { userSchema } from '../normalizr/schemas/user';
import { getDataEntityById, getAllDataEntitiesForSchema } from '../entities';
import objValues from 'lodash/values';
export var getUserById = defaultMemoize(function (state, id) {
    return getDataEntityById(state, userSchema, id);
});
export var getUsersByUsernames = createSelector([
    function (state) { return getAllDataEntitiesForSchema(state, userSchema); },
    function (state, usernames) {
        if (usernames === void 0) { usernames = []; }
        return usernames.map(function (username) { return username.toLowerCase(); });
    },
], function (usersKeyedByIds, usernames) {
    return objValues(usersKeyedByIds).filter(function (user) {
        return usernames.includes(user.username.toLowerCase());
    });
});
export var createGetUsersByIds = function () {
    return createSelector([
        function (state) { return getAllDataEntitiesForSchema(state, userSchema); },
        function (state, ids) { return ids; },
    ], function (usersKeyedByIds, ids) { return ids.map(function (id) { return usersKeyedByIds[id]; }); });
};
export var getUsersByIds = createGetUsersByIds();
//# sourceMappingURL=selectors.js.map